import React, { FC, useEffect, useState } from "react";
import { Box, Grid, Link } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import moment from "moment";
import { ImagesContext } from "../../Context";

const calendarIcon = require("../../../images/calendar.svg");

interface Props {
  question: any;
  index: number;
  handleQuestionAnswer: any;
  formId: number;
}

const DateAnswerSub: FC<Props> = (props: any) => {
  const images = React.useContext(ImagesContext);
  const [dateAnswer, setDateAnswer] = useState<string>(
    moment().format("YYYY-MM-DD")
  );
  const currentDate = moment().format("MM/DD/YYYY");
  const [openDate, setOpenDate] = React.useState<boolean>(false);

  useEffect(() => {
    let tempQ = props.question;
    tempQ["answer"] = dateAnswer;
    props.handleQuestionAnswer(props.index, tempQ);
  }, [dateAnswer]);

  useEffect(() => {
    setDateAnswer(moment().format("YYYY-MM-DD"));
  }, [props.formId]);

  const handleDateChange = (date: moment.Moment | null) => {
    setDateAnswer(date.format("YYYY-MM-DD"));
  };

  return (
    <Grid container>
      <Grid item xs={12} className="q-submission-title">
        {props.question.title}
      </Grid>
      <Box
        className="field-container"
        sx={{
          marginLeft: "0px",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Box
            className="date-box"
            sx={{
              width: "90%",
              maxHeight: 41.13,
              backgroundColor: "#efe9e7",
            }}
          >
            <DemoContainer components={["DatePicker", "DatePicker"]}>
              <DatePicker
                open={openDate}
                onOpen={() => setOpenDate(true)}
                onClose={() => setOpenDate(false)}
                value={moment(dateAnswer, "YYYY-MM-DD")}
                format="MM/DD/YYYY"
                disableOpenPicker
                slotProps={{
                  day: {
                    sx: {
                      "&.Mui-selected": {
                        backgroundColor: "#FF890A",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "#FF890A",
                        },
                      },
                      "&.MuiPickersDay-today": {
                        border: "1px solid #FF890A",
                      },
                      "&.MuiPickersDay-today.Mui-selected": {
                        backgroundColor: "#FF890A",
                        color: "black",
                      },
                    },
                  },
                  textField: {
                    placeholder: currentDate,
                  },
                  openPickerIcon: images.calendar_icon,
                }}
                className="report-date-input no-border-outline"
                maxDate={null}
                onChange={(x) => {
                  handleDateChange(x);
                }}
              />
            </DemoContainer>
          </Box>
        </LocalizationProvider>
        <Link
          className="invite-app-user-link"
          onClick={() => setOpenDate(true)}
        >
          <img
            src={calendarIcon}
            alt="Calendar"
            className="action-icon-image"
            style={{ width: 22.75, maxHeight: 26 }}
          />
        </Link>
      </Box>
    </Grid>
  );
};

export default DateAnswerSub;
